import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs";
import {PageComponent} from "../../../../../core/shared/mvs-page/page.component";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {PageHeaderConfig} from "../../../../../core/shared/service/page/page-header-config.interface";
import {
    MvsConfigHeaderComponent
} from "../../../../../core/shared/components/mvs-config-header/mvs-config-header.component";
import {TabEntries} from "../../../../../core/shared/config/data/tab-entries";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {MvsObjectNavigationEntry} from "../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {MvsObjectNavigationActionEnum} from "../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {ObjectIdentifierData} from "../../../../../core/shared/basic/object-identifier-data";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";


// DEPRECATED
// NOT IN USE
@Component({
    selector: 'mvs-te-config-page',
    templateUrl: './te-config-test.page.html',
    standalone: false
})
export class TeConfigTestPage extends PageComponent implements OnInit, OnDestroy {

  templateGroupWidget: WidgetData;
  templateWidget: WidgetData;
  artefactGroupWidget: WidgetData;
  artefactWidget: WidgetData;
  testCaseWidget: WidgetData;
  systemVariableWidget: WidgetData;
  objectType: string;
  objectId: number;
  activeWidget: TabEntries;
  queryParamSubscription: Subscription;

  widgetEntries: TabEntries[] = [
    {label:'Template Groups', id: 'te.TeTemplateGroup', type: ''},
    {label:'Templates', id: 'te.TeTemplate', type: ''},
    {label:'Artefact Group', id: 'te.TeArtefactGroup', type: ''},
    {label:'Artefact', id: 'te.TeArtefact', type: ''},
    {label:'Test Case', id: 'te.TeTestCase', type: ''},
    {label:'System id', id: 'te.TeSystemVariablePredefined', type: ''},
  ];

  constructor(
      protected route: ActivatedRoute,
      protected coreService: MvsCoreService,
      protected navigationService: MvsObjectNavigationService) {
    super(route, coreService);
  }


  ngOnInit(): void {

    super.ngOnInit();
    this.subscribeToParams();
    this.refreshWidgets();
    this.activeWidget = this.widgetEntries[0];

  }

  ngOnDestroy() {
    if (this.queryParamSubscription) {
      this.queryParamSubscription.unsubscribe();
    }
  }

  subscribeToParams() {
    this.queryParamSubscription = this.route.queryParams.subscribe(params => {
      if (params['tid']) {
        const object = this.widgetEntries.find(item => item.id == params['tid']);
        if (object) {
          this.activeWidget = object;
        }
      }
    });
  }

  refreshWidgets() {
    this.refreshTemplateGroupWidget();
    this.refreshArtefactGroupWidget();
    this.refreshTemplateWidget();
    this.refreshArtefactWidget();
    this.refreshTestCaseWidget();
    this.refreshSystemVariableWidget();
  }

  refreshTemplateGroupWidget() {

      this.templateGroupWidget =  WidgetFactory.createWidgetListEntityBasicQl("te.config.template.group.widget.simple.new", 'Template Groups', 'te.TeTemplateGroup')
  }

  refreshTemplateWidget() {

      this.templateWidget =  WidgetFactory.createWidgetTableEntityBasicQl("te.config.template.widget.simple.new", 'Templates', 'te.TeTemplate')
  }

  refreshArtefactGroupWidget() {

     this.artefactGroupWidget =  WidgetFactory.createWidgetListEntityBasicQl("te.config.artefact.group.widget.simple.new", 'Artefact Groups', 'te.TeArtefactGroup')

  }

  refreshArtefactWidget() {
      this.artefactWidget =  WidgetFactory.createWidgetListEntityBasicQl("te.config.artefact.widget.simple.new", 'Artefact', 'te.TeArtefact')

  }

  refreshTestCaseWidget() {
      this.testCaseWidget =  WidgetFactory.createWidgetListEntityBasicQl("te.config.test.case.widget.simple.new", 'Anlegen', 'te.TeTestCase')

  }

  refreshSystemVariableWidget() {
      this.systemVariableWidget =  WidgetFactory.createWidgetListEntityBasicQl("te.config.system.variable.widget.simple.new", 'Vordefinierte Systemvariablen', 'te.TeSystemVariablePredefined')
  }

  handleTabSelection(item: TabEntries) {
    this.activeWidget = item;
    this.navigationService.navigateTo(MvsObjectNavigationEntry.createNavigationEntry(this.activeWidget.id, null, "", "", "", "", MvsObjectNavigationActionEnum.edit));
  }

  handleTemplateSelect(event: ObjectIdentifierData | ObjectIdentifier) {
    this.objectType = event.objectType;
    this.objectId = event.objectId;
    this.navigationService.navigateTo(MvsObjectNavigationEntry.createNavigationEntry(event.objectType, event.objectId, "object", "", "", "", MvsObjectNavigationActionEnum.edit));
  }

  isConfigurationPage(): boolean {
    return true;
  }

  getPageHeaderConfig(): PageHeaderConfig {
      return {
          component: MvsConfigHeaderComponent,
          inputs: {
              header: 'Template Engine',
              icon: 'fa-solid fa-spell-check'
          },
      };
  }

}
